import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  fill: "none",
  version: "1.1",
  width: "1rem",
  height: "1rem",
  viewBox: "0 0 15.75 15.75"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M0.329505,0.329505C0.768844,-0.109835,1.48115,-0.109835,1.9205,0.329505C1.9205,0.329505,7.875,6.28401,7.875,6.28401C7.875,6.28401,13.8295,0.329505,13.8295,0.329505C14.2688,-0.109835,14.9812,-0.109835,15.4205,0.329505C15.8598,0.768844,15.8598,1.48115,15.4205,1.9205C15.4205,1.9205,9.46599,7.875,9.46599,7.875C9.46599,7.875,15.4205,13.8295,15.4205,13.8295C15.8598,14.2688,15.8598,14.9812,15.4205,15.4205C14.9812,15.8598,14.2688,15.8598,13.8295,15.4205C13.8295,15.4205,7.875,9.46599,7.875,9.46599C7.875,9.46599,1.9205,15.4205,1.9205,15.4205C1.48115,15.8598,0.768844,15.8598,0.329505,15.4205C-0.109835,14.9812,-0.109835,14.2688,0.329505,13.8295C0.329505,13.8295,6.28401,7.875,6.28401,7.875C6.28401,7.875,0.329505,1.9205,0.329505,1.9205C-0.109835,1.48115,-0.109835,0.768844,0.329505,0.329505C0.329505,0.329505,0.329505,0.329505,0.329505,0.329505Z",
        "fill-rule": "evenodd",
        fill: "#8C8C8C",
        "fill-opacity": "1"
      })
    ], -1)
  ])))
}
export default { render: render }